import { __assign, __makeTemplateObject, __rest } from "tslib";
import * as React from 'react';
import { Drop } from 'grommet';
import styled from 'styled-components';
import { px } from '../../utils';
import TooltipArrow from '../../internal/TooltipArrow';
var StyledDrop = styled(Drop)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tborder: 0;\n"], ["\n\tborder: 0;\n"])));
var StyledDropOuter = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tmax-width: 200px;\n\toverflow: auto;\n\tmargin: 5px;\n\tbackground: white;\n\tbox-shadow: ", ";\n\tborder-radius: ", ";\n\tborder: ", ";\n"], ["\n\tmax-width: 200px;\n\toverflow: auto;\n\tmargin: 5px;\n\tbackground: white;\n\tbox-shadow: ", ";\n\tborder-radius: ", ";\n\tborder: ", ";\n"])), function (props) { return '1px 1px 5px' + props.theme.colors.gray.light; }, function (props) { return px(props.theme.radius); }, function (props) { return '1px solid ' + props.theme.colors.gray.main; });
var StyledDropInner = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\tposition: relative;\n"], ["\n\tposition: relative;\n"])));
var getDropAlign = function (placement) {
    switch (placement) {
        case 'bottom':
            return {
                top: 'bottom',
            };
        case 'top':
            return {
                bottom: 'top',
            };
        case 'left':
            return {
                right: 'left',
            };
        case 'right':
            return {
                left: 'right',
            };
    }
};
var BasePopover = function (_a) {
    var placement = _a.placement, target = _a.target, onDismiss = _a.onDismiss, children = _a.children, rest = __rest(_a, ["placement", "target", "onDismiss", "children"]);
    var dropAlign = React.useMemo(function () {
        return getDropAlign(placement);
    }, [placement]);
    return (React.createElement(StyledDrop, __assign({}, rest, { target: target, onClickOutside: onDismiss, onEsc: onDismiss, align: dropAlign, plain: true }),
        React.createElement(TooltipArrow, { placement: placement }),
        React.createElement(StyledDropOuter, null,
            React.createElement(StyledDropInner, null, children))));
};
BasePopover.defaultProps = {
    placement: 'top',
};
export var Popover = BasePopover;
var templateObject_1, templateObject_2, templateObject_3;
